export const DividerEnums = {
	"NONE": "NENHUM",
	"SIMPLE": "SIMPLES",
	"DOBLE": "DUPLA",
	"SEPARATOR": "BARRA_SEPARADORA"
}

export const DividerEnumsConvert = {
	"NENHUM": "none",
	"SIMPLES": "simple",
	"DUPLA": "double",
	"BARRA_SEPARADORA": "separator"
}
